import React, { useEffect, useState } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

export default function DocumentoPDFViewer({ base64 }) {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (!base64) return;

    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const objectUrl = URL.createObjectURL(blob);
      setPdfUrl(objectUrl);

      return () => {
        URL.revokeObjectURL(objectUrl);
      };
    } catch (error) {
      console.error('Error generando Blob para PDF:', error);
    }
  }, [base64]);

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  if (!pdfUrl) return null;

  return (
    <div className="mt-4 text-center">
      <h2
        className="mb-4"
        style={{
          textAlign: 'center',
          color: '#3C8DBC',
          fontWeight: 'bold',
        }}
      >
        Documento
      </h2>

      <div
        style={{
          border: '1px solid #ccc',
          height: '75vh',
          width: '95%',
          maxWidth: '900px',
          margin: '0 auto',
        }}
      >
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
          <Viewer
            fileUrl={pdfUrl}
            plugins={[defaultLayoutPluginInstance]}
          />
        </Worker>
      </div>
    </div>
  );
}
